const sessionManager = (() => {
  let inMemoryToken;

  const removeToken = () => {
    inMemoryToken = null;
    window.piSession.logout();
  };

  const getToken = () => {
    window.piSession.getToken((status, pearsonToken) => {
      inMemoryToken = pearsonToken;
    });
    return inMemoryToken;
  };

  return {
    removeToken,
    getToken,
  };
})();

export const {
  removeToken,
  getToken,
} = sessionManager;
